import React from 'react';
import styled from 'styled-components';
import { Box } from 'rebass';
import colors from 'theme/colors';
import triangle from 'assets/icons/triangle.png';

const SelectWrapper = styled(Box)`
  border: 1px solid ${colors.darkGray};
  margin-bottom: 20px;
`;

const StyledSelect = styled.select<any>`
  width: ${props => props.width};
  height: ${props => props.height};
  background: transparent;
  font-size: 15px;
  font-weight: 500;
  border: none;
  outline: none;
  padding: 0 10px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 0.01px;
  text-overflow: "";
  background: url(${triangle}) 98% no-repeat;
  ::-ms-expand {
    display: none;
  }
}
`;

const Select: React.FC<any> = ({ options, ...props }) => (
  <SelectWrapper>
    <StyledSelect {...props}>
      <option value="" hidden>
        Select here
      </option>
      {options.map((value: string) => (
        <option key={value} value={value}>
          {value}
        </option>
      ))}
    </StyledSelect>
  </SelectWrapper>
);

Select.defaultProps = {
  width: '400px',
  height: '40px',
};

export default Select;
